<template>
<div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3">{{title}}</div>
      <div class="setting-addel mr-l15 mr-r5">
        <el-button size="mini" @click="addPerfOidList"><i class="fas fa-plus"></i></el-button>
        <el-button size="mini" :disabled="!isDeleted" @click="deletePerfOidList"><i class="fas fa-minus"></i></el-button>
      </div>
      <div>
        <el-button size="mini" :disabled="!(changePerfList.length == 1)" @click="onClickCopyOid">템플릿 복제</el-button>
      </div>
    </div>
    <div>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper v-loading="loading" ref="perfOidTable" border :data="dataList" :span-method="objectSpanMethod" :columns="scriptColumns" row-class-name="c-dblclick"
  :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool" @row-dblclick="editPerfDictionary" :pagination="false"
  @condition-change="loadData" remote @selection-change="perfChangeSelection">
    <template slot-scope="scope" slot="templateOidSlot">
      <div v-for="(item, index) in (scope.row.templateRscOid).split(',')" :key="index">
        <span v-if="item">
          {{item}}
        </span>
        <span v-else>
          -
        </span>
      </div>
    </template>
  </el-table-wrapper>
  <w-perf-oid-popup ref="perfOidPopup" @reload-data="loadData" :select-vendor="selectVendor" :is-add="isAdd" :popup-type="popupType" :edit-row="editRow" :rsc-id-list="rscIdList"
    :tmpl-target-type-list="tmplTargetTypeList"></w-perf-oid-popup>
</div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { find, isNil } from 'lodash';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import WPerfOidPopup from '@/views/settings/netdevice/OidSettings/PerformanceOidSettings/popup/PerfOidPopup';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';

export default {
  name: 'WPerfDictionaryView',
  components: {
    WPerfOidPopup,
  },
  props: {
    selectVendor: {
      type: Object,
      default: () => {},
    },
    tmplTargetTypeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      title: '성능 OID 사전',
      loading: false,
      columnDefault,
      popupType: '',
      showSearchTool: false,
      isAdd: false,
      isDeleted: false,
      changePerfList: [], // 선택한 oid List
      editRow: {},
      dataList: [],
      scriptColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'dictCategory',
          label: '사전 종류',
          width: 150,
          remoteProp: 'template.dictCategory',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'dictInfo',
          label: '사전 정보',
          remoteProp: 'template.dictInfo',
          sortable: true,
          searchable: true,
          formatter: this.dicInfoFormatter,
        },
        {
          prop: 'templatetypeRscName',
          label: '성능 이름',
          width: 150,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'templateRscOid',
          label: '성능 OID',
          remoteProp: 'rsc_tmpl.templatetype_rsc_oid',
          searchable: true,
          scopedSlot: 'templateOidSlot',
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      rscIdList: [],
      perfOidInfo: [],
    };
  },
  watch: {
    changePerfList: {
      handler() {
        if (this.changePerfList.length > 0) {
          this.isDeleted = true;
        } else {
          this.isDeleted = false;
        }
      },
      immediate: true,
    },
    selectVendor: {
      immediate: true,
      handler(val) {
        if (val) {
          this.title = `[${val.objCompanyName}] 성능 OID 사전`;
          this.loadData();
        } else {
          this.title = '성능 OID 사전';
        }
      },
    },
  },
  methods: {
    /**
     * 성능자원 동적로드를 하기 때문에 조회한 row 갯수만큼 index를 설정한다.
     * @author  Song
     */
    objectSpanMethod({ row, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        if (!isNil(row.rowCount)) {
          return { rowspan: row.rowCount, colspan: 1 };
        }
        return { rowspan: 1, colspan: 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    /**
     * [loadData perfOidDictionartView의 상위 뷰에 load를 요청]
     * 19. 09. 23 SKCC nms_rsc_tmpl_info 자원이 총 7개로 추가되었으며 해당 templatetypeRscId는 고정형식 -> 동적로드로 변경
     *
     * @author  yelim - Song
     */
    loadData() {
      const tableParams = this.$refs.perfOidTable.getParameter();
      const params = {
        objCompanyId: this.selectVendor.objCompanyId,
        ...tableParams,
      };
      // TODO: 이전 oid 값 일부 남아있는 현상 있음. dom 재사용 연관된 문제로 추측.
      // 정확한 원인 파악과 해결책을 찾지 못해 임시로 table data 초기화 후 response의 data를 넣도록 하여 이전 dom이 남아있지않도록 대응. 추후 개선 필요
      // ScheduleView.vue도 동일 증상 있어 동일한 방식으로 임시 처리.
      this.dataList = [];
      this.loading = true;

      // templatetypeRscId 조회
      NetdeviceSettingAPI.getNmsRscTmplInfoRscList().then((res) => {
        if (res.data.success) {
          this.rscIdList = cloneDeep(res.data.data);
          // 성능 OID 사전 목록 조회
          NetdeviceSettingAPI.getPerfOidList(params).then((result) => {
            if (result.data.success) {
              this.dataList = result.data.data;
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '성능 OID', false));
            }
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '성능 OID', false));
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    /**
     * [addPerfOidList 선택한 벤더의 OID 사전 항목을 추가한다.]
     * @author yelim
     */
    addPerfOidList() {
      this.isAdd = true;
      this.editRow = {};
      this.popupType = 'ADD';
      this.$refs.perfOidPopup.open();
    },
    /**
     * [deletePerfOidList 선택한 벤더의 OID 사전 항목을 삭제한다.]
     * 장비템플릿 추가 - 관련 장비를 모두 삭제해주어야한다. templateGroupId를 통해 삭제하도록 변경
     * @author yelim - Song
     */
    deletePerfOidList() {
      const target = '성능 OID';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        NetdeviceSettingAPI.deletePerfOidList(this.changePerfList).then((result) => {
          if (result.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    /**
     * [editPerfDictionary 선택한 벤더의 OID 사전 항목을 수정할 수 있는 팝업을 띄운다.]
     * 2019. 09. 23 SKCC 추가건 - 기존 CPU/MEM/온도 고정적인 구조에서 CPU/MEM/온도/모듈상태/모듈온도/CPS/세션 수로 변경 (동적)
     *
     * @author yelim - Song
     */
    editPerfDictionary(row) {
      this.isAdd = false;
      const editPerfRow = cloneDeep(row);
      // 성능 이름에 따른 성능 OID를 팝업에 설정하기 위한 데이터 가공
      const rscIdList = this.rscIdList;
      for (let i = 0; i < rscIdList.length; i += 1) {
        const templatetypeRscId = rscIdList[i].templatetypeRscId;
        const findData = (find(this.dataList, (item) => (item.templateId === row.templateId && item.templatetypeRscId === templatetypeRscId)));

        editPerfRow[templatetypeRscId] = [{
          oid: findData ? findData.templateRscOid : '',
          snmpRequestType: findData ? findData.snmpRequestType : 'GET',
        }];
      }
      this.editRow = editPerfRow;
      this.popupType = 'EDIT';
      this.$refs.perfOidPopup.open();
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [perfChangeSelection 병합 row 테이블에 대한 선택 이벤트]
     * 병합 row 특성 상 하나의 row를 클릭한 것 같지만 선택 시 병합된 row들 정보를 모두 가지고 있음, 그에 따른 처리 수행
     * @author  Song
     */
    perfChangeSelection(selectVal) {
      // 반복 돌려서 선택한 데이터에서는 rowCount가 있는 녀석만 고르도록 하고, 상태를 관리하게 수정 (2020. 02. 11. Song)
      const selectValClone = cloneDeep(selectVal);
      this.changePerfList = selectValClone.filter((val) => val.rowCount);
    },
    /**
     * [dicInfoFormatter 장비 템플릿 - 선택된 장비 갯수 표시]
     * @author  Song
     */
    dicInfoFormatter(row, column, value) {
      let result = `${value}`;
      if (row.templateTargetType === 'TARGET_OBJ') {
        result += row.deviceCount === 1 ? '' : ` 외 ${row.deviceCount - 1}개 장비`;
      }
      return result;
    },
    /**
     * [onClickCopyOid 템플릿 복제 기능]
     * @author  Song
     */
    onClickCopyOid() {
      const targetCopyTmpl = this.dataList.filter((value) => value.templateGroupId === this.changePerfList[0].templateGroupId);
      this.isAdd = true;
      this.editRow = {};
      this.popupType = 'ADD';
      this.$refs.perfOidPopup.open(targetCopyTmpl);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/PerformanceOidSettings/component/PerfOidDictionaryView.vue